/** Build-time blog slug redirects (mirrors src/lib/blogSlugs.ts). */

export const BLOG_TR_SLUG_BY_EN = {
  'custom-software-development-company-guide': 'ozel-yazilim-gelistirme-sirketi-nasil-secilir',
  'ai-development-company-selection-guide': 'ai-gelistirme-sirketi-nasil-secilir',
  'saas-development-cost-guide': 'saas-gelistirme-maliyeti-rehberi',
  'mobile-app-development-cost-guide': 'mobil-uygulama-gelistirme-maliyeti',
  'chatgpt-integration-business-guide': 'chatgpt-entegrasyonu-isletme-rehberi',
  'mvp-development-company-guide': 'mvp-gelistirme-sirketi-rehberi',
  'ux-design-in-ai-products': 'ai-urunlerinde-ux-tasarimi',
  'saas-scaling-strategies': 'saas-olceklendirme-stratejileri',
  'modern-fullstack-tooling': 'modern-fullstack-araclari',
  'mvp-development-guide': 'mvp-gelistirme-rehberi',
  'mobile-app-performance-optimization': 'mobil-uygulama-performans-optimizasyonu',
  'data-security-and-compliance': 'veri-guvenligi-ve-uyumluluk',
};

export function buildBlogTrSlugRedirectLines() {
  return Object.entries(BLOG_TR_SLUG_BY_EN).flatMap(([enSlug, trSlug]) => {
    if (enSlug === trSlug) return [];
    return [
      `/tr/blog/${enSlug}       /tr/blog/${trSlug}       301`,
      `/tr/blog/${enSlug}/      /tr/blog/${trSlug}       301`,
    ];
  });
}
